import React from "react";
import { motion } from "framer-motion";

export default function CtaSection() {
  return (
    <section className="py-24 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="overflow-hidden rounded-3xl border border-blue-200/60 bg-white shadow-lg">
          <div className="grid grid-cols-1 md:grid-cols-3">
            <div className="md:col-span-2 p-10">
              <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900">Ready to Get Started?</h2>
              <p className="mt-3 text-lg text-gray-600 max-w-xl">Free consultation, real humans, and a clear plan. Let’s make this simple.</p>

              <div className="mt-8 flex flex-col sm:flex-row gap-4">
                <motion.a
                  href="tel:+1 3108802133"
                  className="inline-flex items-center justify-center rounded-full bg-blue-600 px-7 py-4 font-semibold text-white shadow"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.95.68l1.5 4.5a1 1 0 01-.5 1.2l-2.26 1.13a11.04 11.04 0 005.52 5.52l1.13-2.26a1 1 0 011.2-.5l4.5 1.5c.4.13.68.5.68.95V19a2 2 0 01-2 2h-1C9.72 21 3 14.28 3 6V5z" />
                  </svg>
                  Call +1 3108802133
                </motion.a>
                <motion.a
                  href="/contact"
                  className="inline-flex items-center justify-center rounded-full border-2 border-blue-600 px-7 py-4 font-semibold text-blue-700"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.98 }}
                >
                  Contact Us
                </motion.a>
              </div>
            </div>

            <div className="relative p-10 bg-gradient-to-br from-blue-700 via-blue-600 to-sky-600 text-white">
              <div className="absolute -top-16 -right-16 h-40 w-40 rounded-full bg-white/20 blur-2xl" />
              <div className="relative">
                <h3 className="text-xl font-semibold">Why now?</h3>
                <ul className="mt-4 space-y-3 text-blue-50">
                  {["Faster form prep and review", "Transparent pricing, no hidden fees", "Vetted lawyers when you need them"].map((x, i) => (
                    <li key={i} className="flex items-center gap-2 rounded-lg bg-white/10 ring-1 ring-white/15 px-3 py-2">
                      <svg className="w-[20px] h-[20px]" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      {x}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}